import React from "react";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import WaterDropIcon from "@mui/icons-material/WaterDrop";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";

const Aboutus = () => {
  return (
    <>
      <style>{`
        .about-page {
          padding: 40px 20px;
          max-width: 1000px;
          margin: auto;
          font-family: "Poppins", sans-serif;
        }

        .about-title {
          text-align: center;
          font-size: 32px;
          font-weight: 800;
          margin-bottom: 30px;
          color: #022c32;
        }

        .about-card {
          background: rgba(255,255,255,0.7);
          backdrop-filter: blur(12px);
          padding: 25px;
          border-radius: 14px;
          box-shadow: 0 4px 14px rgba(0,0,0,0.1);
          margin-bottom: 25px;
          transition: .3s;
        }

        .about-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 20px rgba(0,0,0,0.15);
        }

        .about-head {
          display: flex;
          align-items: center;
          gap: 12px;
          font-size: 22px;
          font-weight: 700;
          color: #03b8b3;
          margin-bottom: 10px;
        }

        .about-icon {
          font-size: 30px;
          color: #03b8b3;
        }

        .about-text {
          font-size: 15px;
          color: #053b42;
          line-height: 1.6;
        }

        @media (max-width: 600px) {
          .about-title { font-size: 26px; }
          .about-head { font-size: 20px; }
        }
      `}</style>

      <div className="about-page">
        <h2 className="about-title">About Us</h2>

        <div className="about-card">
          <div className="about-head">
            <LocalShippingIcon className="about-icon" />
            Fast & Reliable Water Delivery
          </div>
          <p className="about-text">
            RefreshH2O is committed to providing **clean, safe & fresh RO
            water** at your doorstep. Whether it's your **home, office, events
            or hotels**, we ensure timely delivery with professional service.
            Our delivery team works round-the-clock to make sure you never run
            out of healthy drinking water.
          </p>
        </div>

        <div className="about-card">
          <div className="about-head">
            <WaterDropIcon className="about-icon" />
            Purity You Can Trust
          </div>
          <p className="about-text">
            Your health is our top priority. Our water goes through
            **multi-stage filtration, RO, UV & mineral balancing** ensuring
            every drop is pure, safe and refreshing 🫧 We follow strict hygiene,
            sealed bottle process and **regular quality checks**.
          </p>
        </div>

        <div className="about-card">
          <div className="about-head">
            <VerifiedUserIcon className="about-icon" />
            Trusted by Hundreds of Families & Businesses
          </div>
          <p className="about-text">
            We proudly serve **schools, gyms, apartments, hostels, restaurants &
            corporate offices** across the city. Our customers trust us for:
            <br />✅ Genuine sealed jars
            <br />✅ Affordable pricing
            <br />✅ On-time delivery
            <br />✅ Friendly support Experience a service that cares for your
            family’s hydration 💙
          </p>
        </div>
      </div>
    </>
  );
};

export default Aboutus;
